  <!-- TrustBox widget - Mini -->
  <div class="trustpilot-widget {{displayClass}}" *ngIf="trustpilotType == 'mini'"
       data-locale="de-DE"
       data-template-id="53aa8807dec7e10d38f59f32"
       data-businessunit-id="6176575fa2f7e91d56648106"
       data-style-height="110px"
       data-style-width="240px"
       [attr.data-theme]="trustpilotTheme">
    <a href="https://de.trustpilot.com/review/advofin.at" target="_blank" rel="noopener">Trustpilot</a>
  </div>
  <!-- End TrustBox widget -->

  <!-- TrustBox widget - Micro Star -->
  <div class="trustpilot-widget {{displayClass}}" *ngIf="trustpilotType == 'micro'"
       data-locale="de-DE" data-template-id="5419b732fbfb950b10de65e5"
       data-businessunit-id="6176575fa2f7e91d56648106" data-style-height="24px" data-style-width="100%"
       [attr.data-theme]="trustpilotTheme">
    <a href="https://de.trustpilot.com/review/advofin.at" target="_blank" rel="noopener">Trustpilot</a>
  </div>
  <!-- End TrustBox widget -->
